const coinbaseEscrowSlideshowIndex = (state = 0, action) => {
  switch (action.type) {
      case 'SET_COINBASE_ESCROW_SLIDESHOW_INDEX':
          return action.index
      default:
          return state
  }
}

export default coinbaseEscrowSlideshowIndex;